import Banner from '@v2/shared/components/Banner';
import Section from '@v2/shared/components/Section';
import ProductBand from '@v2/shared/components/ProductBand';
import CategoryBand from '@v2/shared/components/CategoryBand';
import { Banner as BannerType, Category } from '@v2/shared/lib/types';

export interface Props {
  categories: Category[];
  featuredCategories: Category[];
  banners: BannerType[];
}

/**
 * The books landing page, previously served by headless_jshop.
 *
 * `categories` are the children of the books-homepage curation category and become the
 * product bands; `featuredCategories` are the featured children of the books tree and
 * become "Our Top Categories". They are different lists from different parents — see
 * BooksPagePropsBuilder, which explains the split.
 *
 * The sale banners arrive as props rather than being fetched on mount as headless did
 * with useBanners('HOMEPAGE_BOOKS'). They are the first thing on the page, so fetching
 * them client-side would leave the top of the page empty on the first paint and shift
 * everything below once they landed.
 */
export default function Books({ categories, featuredCategories, banners }: Props) {
  // The box, its measure and its spacing are all Layouts.Full's. This page has nothing
  // to say about any of them.
  return (
    <>
      {banners.length > 0 && (
        <Section>
          {banners.map((banner, key) => (
            <Banner key={key} banner={banner} />
          ))}
        </Section>
      )}

      {categories.map((category) => (
        <ProductBand key={category.id} title={category.name} products={category.products ?? []} />
      ))}

      <CategoryBand title="Our Top Categories" categories={featuredCategories} />
    </>
  );
}

Books.layoutName = 'Layouts.Full';
